// 数字图书
const zsxxwRoutes = Array.from({ length: 17 }, (_, i) => ({
  path: `books/zsxxw/index${i + 1}`,
  name: `books/zsxxw/Index${i + 1}`,
  component: () => import(`@/views/study/books/zsxxw/index${i + 1}.vue`)
}))


import booksIndex from '@/views/study/books/index'



export default {
  path: '/study',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'books/index',
        name: 'booksIndex',
        component: booksIndex
      },
    // 数字图书，开始
    ...zsxxwRoutes,
    // 数字图书，结束


  ],
};
